<script>
    import ApexCharts from 'apexcharts'
    import { onMount, onDestroy } from 'svelte'
    import { statisticsStore } from '../../stores/Statistics'
    import { t } from 'totalinvoice-frontend-core'

    let container
    let chart

    const options = {
        chart: {
            id: 'one-month-requests',
            group: 'one-month-data',
            type: 'area',
            height: 160,
            sparkline: {
                enabled: true
            },
        },
        stroke: {
            curve: 'straight'
        },
        fill: {
            opacity: 1,
        },
        series: [],
        yaxis: {
            min: 0
        },
        xaxis: {
            type: 'datetime',
        },
        colors: ['#DCE6EC'],
        title: {
            text: '0',
            offsetX: 30,
            style: {
                fontSize: '24px',
                cssClass: 'apexcharts-yaxis-title'
            }
        },
        subtitle: {
            text: $t('Requests'),
            offsetX: 30,
            style: {
                fontSize: '14px',
                cssClass: 'apexcharts-yaxis-title'
            }
        },
        noData: {
            text: $t('Loading...'),
        }
    }

    let initialized = false
    let rendered = false

    onMount(() => {
        chart = new ApexCharts(container, options)
        chart.render().then(() => {
            initialized = true
        })
    })

    onDestroy(() => {
        chart.destroy()
    })

    $: if (initialized === true && rendered === false && $statisticsStore.requestsByDay.data) {
        const series = $statisticsStore.requestsByDay

        // only use data of the last 30 days
        series.data = series.data.slice(Math.max(series.data.length - 30, 0))

        // compute sum
        let count = 0
        series.data.forEach(d => count += d[1])

        // translate name of series
        series.name = $t(series.name)
        
        chart.updateOptions({ title: { text: count } }, false, true, false)
        chart.updateSeries([series])

        rendered = true
    }
</script>

<div bind:this={container} />
